import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LanguageProvider } from "@/i18n";
import { Toaster } from "@/components/ui/sonner";
import PwaInstallPrompt from "@/components/PwaInstallPrompt";
import Home from "@/pages/Home";
import BeritaDetail from "@/pages/BeritaDetail";
import AtletDetail from "@/pages/AtletDetail";
import AtletList from "@/pages/AtletList";
import PrestasiList from "@/pages/PrestasiList";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ParentLogin from "@/pages/ParentLogin";
import ParentDashboard from "@/pages/ParentDashboard";
import DaftarUlang from "@/pages/DaftarUlang";
import KartuPreview from "@/pages/KartuPreview";
import AuthCallback from "@/pages/AuthCallback";

function Protected({ children, roles }) {
    const { user } = useAuth();
    if (user === null) return <div className="min-h-screen bg-white" />;
    if (user === false) return <Navigate to={roles?.includes("parent") ? "/login" : "/admin/login"} replace />;
    if (roles && !roles.includes(user.role)) {
        const target = user.role === "parent" ? "/portal" : "/admin";
        return <Navigate to={target} replace />;
    }
    return children;
}

function AppRoutes() {
    const location = useLocation();
    // Deteksi session_id dari hash SECARA SINKRON saat render (bukan useEffect) agar AuthCallback
    // berjalan sebelum Protected route manapun — mencegah race condition.
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/berita/:id" element={<BeritaDetail />} />
            <Route path="/atlet" element={<AtletList />} />
            <Route path="/prestasi" element={<PrestasiList />} />
            <Route path="/atlet/:id" element={<AtletDetail />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Protected roles={["admin", "finance", "coach"]}><AdminDashboard /></Protected>} />
            <Route path="/login" element={<ParentLogin />} />
            <Route path="/daftar-ulang" element={<Navigate to="/login" replace />} />
            <Route path="/daftar-siswa-baru" element={<DaftarUlang mode="new" />} />
            <Route path="/portal" element={<Protected roles={["parent"]}><ParentDashboard /></Protected>} />
            <Route path="/kartu/:source/:id" element={<Protected roles={["admin", "finance", "coach", "parent"]}><KartuPreview /></Protected>} />
        </Routes>
    );
}

function App() {
    return (
        <LanguageProvider>
        <AuthProvider>
            <BrowserRouter>
                <AppRoutes />
            </BrowserRouter>
            <PwaInstallPrompt />
            <Toaster theme="dark" position="top-right" />
        </AuthProvider>
        </LanguageProvider>
    );
}

export default App;
